import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=0e2d4e5b&scoped=true&"
import script from "./workDetail.vue?vue&type=script&lang=js&"
export * from "./workDetail.vue?vue&type=script&lang=js&"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=0e2d4e5b&prod&lang=css&"
import style1 from "./workDetail.vue?vue&type=style&index=1&id=0e2d4e5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d4e5b",
  null
  
)

export default component.exports